import React, { useState } from 'react';
import { Form, Input, Button, Checkbox, message } from 'antd';
import * as API from '@/services';

const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};
const tailLayout = {
    wrapperCol: { offset: 8, span: 16 },
};
const newIptStyle = {
    borderTop: 'none',
    borderLeft: 'none',
    borderRight: 'none',
    boxShadow: 'none',
    borderRadius: '0px'
}

const LoginForm = () => {
    const [loginForm] = Form.useForm();
    const [isCheck, setIsCheck] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);

    const onFinish = (values) => {
        console.log('Success:', values);
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    const onChangeCheck = (e) => {
        setIsCheck(e.target.checked);
    }
    const handleSubmit = () => {
        if(!isCheck) {
            message.warning('请同意用户协议');
            return;
        }
        if(btnLoading) return;
        let domain = document.domain;
        domain = domain.split('.');
        let len = domain.length;
        let domain1 = `.${domain[len - 2]}.${domain[len - 1]}`;
        let domain2 = `.${domain[len - 3]}.${domain[len - 2]}.${domain[len - 1]}`;
        document.cookie = `_security_token=0;expires=${new Date().toUTCString()};path=/;domain=${domain1}`;
        document.cookie = `_security_token=0;expires=${new Date().toUTCString()};path=/;domain=${domain2}`;
        document.cookie = `_security_token=0;expires=${new Date().toUTCString()};path=/`;
        loginForm.validateFields().then(res=>{
            setBtnLoading(true);
            const param = {...res, loginType: 'MobilePasswordGroup'};
            API.submitDataByLogin(param).then((token)=>{
                let url = `${process.env.MUJI_APP_HOST}/#/`;
                document.cookie = '_security_token' + "=" + token + `;path=/;domain=${domain1}`;
                document.cookie = '_security_token' + "=" + token + `;path=/;domain=${domain2}`;
                document.cookie = '_security_token' + "=" + token + `;path=/`;
                setTimeout(() => { window.location.href = url;})
            }).finally(()=>{
                setBtnLoading(false);
            })
        });
    }


    return (
        <Form
            form={loginForm}
            style={{ width: '100%' }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
        >
            <Form.Item
                name="group"
                rules={[{ required: true, message: '请输入集团编码' }]}
            >
                <Input placeholder="集团编码"  style={newIptStyle}/>
            </Form.Item>
            <Form.Item
                name="mobile"
                rules={[{ required: true, message: '请输入用户名/手机号码' }]}
            >
                <Input placeholder="用户名/手机号码" style={newIptStyle}/>
            </Form.Item>

            <Form.Item
                name="password"
                rules={[{ required: true, message: '请输入密码' }]}
            >
                <Input.Password placeholder="密码" style={newIptStyle}/>
            </Form.Item>

            <Form.Item>
                <>
                    <Checkbox onChange={onChangeCheck} style={{fontSize: '12px', color: '#999999'}}>
                        已阅读并同意
                    </Checkbox>
                    <a href="https://agreement.souche.com/online/agreement/98.html" target="_blank" style={{fontSize: '12px', marginRight: '20px'}}>《用户协议》</a>
                    <a style={{fontSize: '12px'}}>忘记密码</a>
                </>
            </Form.Item>
            <Form.Item >
                <Button type="primary" size="large" loading={btnLoading} onClick={handleSubmit} style={{ width: '100%', background: '#1D48F5' }}>
                    {btnLoading ? '登录中...' : '登录'}
                </Button>
            </Form.Item>
        </Form>
    );
};

export default LoginForm;
